import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { updateProfile } from "../../../services/superAdminApis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Loader from "../../utilComponents/loader";

const FullNameModal = ({ show, handleClose }) => {
  const [FullName, setFullName] = useState("");
  const [loading, setLoading] = useState(false);

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateProfile,
    mutationKey: ["changeFullName"],
    onSuccess: () => {
      setLoading(false);
      queryClient.invalidateQueries(["userProfile"]); // Refresh profile data
      handleClose();
    },
    onError: (error) => {
      setLoading(false);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    mutation.mutate({ FullName });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      {loading && <Loader />}
      <Modal.Header closeButton>
        <Modal.Title>Edit Profile</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              type="text"
              value={FullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" variant="warning">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FullNameModal;
